import React from "react";
import { GridCellTooltip } from "../GridCellTooltip/GridCellTooltip";
import tableStyles from "../../PreviewImportModalTable.module.css";
import { stringifyValue } from "../../PreviewImportModal.utils";
import type { FieldRowProps } from "./FieldRow.types";
import { getDestinationValueAriaLabel } from "./FieldRow.utils";

export const FieldRow: React.FC<FieldRowProps> = ({
  row,
  value,
  onValueChange,
}) => {
  const parentValue = stringifyValue(row.ParentValue);

  return (
    <tr>
      <td className={tableStyles.descriptionCell}>
        <GridCellTooltip text={row.ParentFieldDescription} />
      </td>
      <td className={tableStyles.valueCell}>
        <GridCellTooltip text={parentValue} />
      </td>
      <td className={tableStyles.arrowCell} aria-hidden="true">
        <span className={tableStyles.arrowText}>&rarr;</span>
      </td>
      <td className={tableStyles.descriptionCell}>
        <GridCellTooltip text={row.ChildFieldDescription} />
      </td>
      <td className={tableStyles.valueCell}>
        <input
          className={tableStyles.valueInput}
          value={value}
          onChange={(event) => onValueChange(event.target.value)}
          aria-label={getDestinationValueAriaLabel(row)}
        />
      </td>
    </tr>
  );
};
